<template>
  <div class="bg-gray-200 mr-0 overflow-y-auto w-full maincomponent-area">
    <UsersGrid />
  </div>
</template>

<script>
import UsersGrid from "./UsersGrid";

export default {
  name: "userslist",
  components: { UsersGrid }
};
</script>
